import { Fieldset } from '@paytrace/pt-skel/Component'
import * as React from 'react'
import { AlertIcon } from '../../Icons/AlertIcon'
import { AmountsDisplay } from './AmountsDisplay'
import { ResponseInformation } from './ResponseInformation'
import { TransactionPageProps } from './ResponsePage'
import { ViewAndEmailReceipt } from './SaveAndEmailReceipt'

export function DeclinedView ({ props, orderId }: { props: TransactionPageProps; orderId: string }) {
  return (
    <Fieldset className={'entire-view'}>
      <div className="uid-tranx-app-clear clear"></div>
      <div className="uid-tranx-app-error center error giant-text">Not Approved</div>
      <br />

      <ResponseInformation
        title="Transaction Information:"
        responseMessage={props.approval_message || props.response_message}
        orderId={orderId}
        amountDisplay={<AmountsDisplay props={props} isDeclined={true} />}
        actionButtons={
          <>
            <button className="action-btn" onClick={props.onTransactionReprocess}>New Transaction</button>
          </>
        }
      >
        <tr>
          <td className="response-info-label"><strong>Amount:</strong></td>
          <td className="uid-tranx-app-transaction-amount">${Number(props.amount).toFixed(2)}</td>
        </tr>
      </ResponseInformation>

      <ViewAndEmailReceipt
        orderId={orderId}
        merchantId={props.merchant}
        initialEmails={props.emails}
      />

      <div className="warning warning-banner">
        <AlertIcon />
        &nbsp;Warning - Please do not click the back or refresh buttons as this may cause your transaction to be duplicated.
      </div>
    </Fieldset>
  )
}
